import PortalNewOrderContainer from '@components/containers/b2b/portal/PortalNewOrder';
import { B2B_NAV_ITEMS } from '@constants/sidebar';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const PortalNewOrder: FC = () => (
    <VendorLayout navItems={B2B_NAV_ITEMS}>
        <PortalNewOrderContainer />
    </VendorLayout>
);

export default PortalNewOrder;
